import Dashboard from "./Admin/pages/home/HomeAdmin";
import AdminLogin from "./Admin/pages/login/AdminLogin";
import List from "./Admin/pages/list/List";
import ProductList from "./Admin/pages/list/product";
import Single from "./Admin/pages/single/singleUser";
import SingleProduct from "./Admin/pages/single/singleProduct";
import Orders from "./Admin/pages/orders/orders";
import NewAdmin from "./Admin/pages/new/adminNew";
import NewProduct from "./Admin/pages/new/newProduct";
import Delivery from "./Admin/pages/delivery/delivery";
import Stats from "./Admin/pages/stats/stats";
import FilterStats from "./Admin/pages/stats/filterStats";
import Notification from "./Admin/pages/notifications/notifications";
import SystemHealth from "./Admin/pages/systemHealth/systemHealth";
import AdminProfile from "./Admin/pages/profile/admProfile";
import Logs from "./Admin/pages/logs/logs";
import Settings from './Admin/pages/settings/settings'
import ProductUpdate from './Admin/pages/update/productUpdate'
import Payment from './Admin/pages/payment/payment'
import Invoice from './Pages/payments/invoice/invoice'

import "./Admin/style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./Admin/context/darkModeContext";

import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Home from './Pages/Home/home'
import About from './Pages/About/about'
import Contact from './Pages/Contact/contact'
import Medici from './Pages/Medicine/medici'
import News from './Pages/News/news'
import Login from './Pages/Login/login'
import Register from './Pages/Register/register'
import ProgressBar from './Components/ProgressBar/progressBar'
import Cart from './Pages/Cart/cart'
import YourOrders from './Pages/Orders/yourOrders'
import ProdDesc from './Pages/productDetails/productDetails'
import UserProfile from './Pages/Profile/userProfile'
import ForgetPassword from './Pages/Forget/forgetPassword'
import UserPayment from './Pages/payments/userPayment'

import { CartProvider } from './Components/reducer/contextReducer'

function App() {
  const { darkMode } = useContext(DarkModeContext)
  return (
    <div className={darkMode ? "app dark" : "App"}>
      <CartProvider>
        <Router>
          <ProgressBar />
          <Routes>
            <Route path='/' >
            <Route index element={<Home />} />
            <Route path='about' element={<About />} />
            <Route path='contact' element={<Contact />} />
            <Route path='medici' element={<Medici />} />
            <Route path='news' element={<News />} />
            <Route path='login' element={<Login />} />
            <Route path='register' element={<Register />} />
            <Route path='cart' element={<Cart />} />
            <Route path='myOrders' element={<YourOrders />} />
            <Route path='productDetails' element={<ProdDesc />} />
            <Route path='userProfile' element={<UserProfile />} />
            <Route path='forgetPassword' element={<ForgetPassword />} />
              <Route path='userPayment' element={<UserPayment />} />
              <Route path='invoice' element={<Invoice />} />              

            {/*admin*/}
            <Route path='admin' element={<Dashboard />} />
            <Route path='orders' element={<Orders />} />
            <Route path='adminLogin' element={<AdminLogin />} />
            <Route path='delivery' element={<Delivery />} />
              <Route path='stats' element={<Stats />} />
              <Route path='filterStats' element={<FilterStats />} />              
              <Route path='notifications' element={<Notification />} />
              <Route path='systemHealth' element={<SystemHealth />} />
              <Route path='admProfile' element={<AdminProfile />} />
              <Route path='logs' element={<Logs />} />
              <Route path='settings' element={<Settings />} />
              <Route path='payment' element={<Payment/>} />
            <Route path='adminUsers'>
              <Route index element={<List />} />
              <Route exact path=':id' element={<Single />} />
              <Route path='adminNew' element={<NewAdmin />}/>
              </Route>
              <Route path="productUpdate">
                <Route path=':upProdId' element={<ProductUpdate />} />
              </Route>              
              <Route path='adminProducts'>
                <Route index element={<ProductList />} />
                <Route path=':productId' element={<SingleProduct />}/>

                <Route path='newProduct' element={<NewProduct />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </CartProvider>
    </div>
  );
}

export default App;
